// Eyebrow + title + optional subtitle block used across sections.
export const SectionTitle = ({ overline, title, subtitle, center = false, light = false, className = "" }) => (
  <div className={`${center ? "mx-auto max-w-2xl text-center" : "max-w-2xl"} ${className}`}>
    {overline && (
      <span className={`overline ${light ? "!text-brand-lilac" : ""}`}>{overline}</span>
    )}
    <h2
      className={`mt-3 font-heading text-3xl font-bold tracking-tight sm:text-4xl ${
        light ? "text-white" : "text-ink"
      }`}
    >
      {title}
    </h2>
    {subtitle && (
      <p className={`mt-4 text-base leading-relaxed ${light ? "text-white/70" : "text-ink-soft"}`}>
        {subtitle}
      </p>
    )}
  </div>
);
